export function getCreationRestrictionCopy(statusInfo, subjectLabel) {
  const status = statusInfo || {};
  const subject = subjectLabel || 'Content';
  const baseHeadline = `${subject} Creation Restricted`;

  if (status.is_banned) {
    return {
      blocked: true,
      headline: baseHeadline,
      detail: 'Your account is banned from community participation.',
      support: 'Contact a community administrator if you believe this is an error.'
    };
  }

  if (status.currently_suspended) {
    return {
      blocked: true,
      headline: baseHeadline,
      detail: 'Your account is currently suspended. Creation is unavailable right now.',
      support: 'Please reach out to a community administrator for additional help.'
    };
  }

  if (status.can_post === false) {
    return {
      blocked: true,
      headline: baseHeadline,
      detail: 'Posting privileges are currently disabled for your account.',
      support: 'Contact a community administrator if you need your access reinstated.'
    };
  }

  return { blocked: false };
}
